import { PolicyDto } from '../commonTypes/leaveRequest.types';
import {
    CreateOrganizationDto,
    OrganizationDto,
    OrganizationPublicDto,
    OrganizationWithPolicies,
    PatchOrganizationDto,
    SendInviteEmailsBody,
    UserAskedToJoin,
    PublicPolicyDto,
    CreatePolicyDto,
    EditPolicyDto,
    CreateBranchDto,
    BranchDto,
    EditBranchDto,
    HolidaysWithBranchesDto,
    BranchesCountDto,
    CreateHolidayDto,
    HolidayDto,
    EditHolidayDto,
    GoogleImportDto,
    GoogleImportHolidayDto,
    CreateGoogleHolidaysDto,
    CurrencyDto,
    TimezoneDto,
    PolicyWithBranches,
    TeamDto,
    EditTeamDto,
    CreateTeamDto,
    ChangeTeamLeadDto,
    FeatureFlagsDto,
    SettingsDto,
    PolicyAndMedicalLeaveBaseDto,
    EditMedicalLeaveDto,
    MedicalLeaveDto,
    MedicalLeaveRequirements,
    PricingPlanDto,
    CardPaymentMethodDto,
    UpdateCardPaymentMethodDto,
    ActiveSubscriptionResponseDto,
    FeatureConfigResponseDto,
    GetForFeatureWithPlanResponseDto,
} from '../commonTypes/organization.types';
import { BillingInvoiceDto } from '../components/BillingInvoicesTable';
import { diContainer } from '../libs/container';
import { ApiBaseClass, IServiceHttp } from './ApiBase';

export namespace OrganizationApiRequest {
    export interface AskToJoinOrganization {
        params: {
            organizationId: string;
        };
    }

    export interface PoliciesByBranchAndOrganization {
        params: {
            branchId: string;
            organizationId: string;
        };
    }

    export interface CreateOrganization {
        body: CreateOrganizationDto;
    }

    export interface PatchOrganization {
        params: {
            organizationId: string;
        };
        body: PatchOrganizationDto;
    }

    export interface SendInviteEmails {
        body: SendInviteEmailsBody;
    }

    export interface UsersAskedToJoinOrganization {
        params: {
            organizationId: string;
        };
    }

    export interface GetOrganizationByOwnerId {
        query: {
            ownerId: string;
        };
    }

    export interface PatchPolicy {
        params: {
            id: string;
        };
        body: EditPolicyDto;
    }
    export interface ChangeAffectedMembers {
        params: {
            id: string;
        };
        body: {
            ids: string[];
        };
    }

    export interface GetOrganizationById {
        params: {
            organizationId: string;
        };
    }

    export interface GetAllPolicies {}

    export interface GetAllPoliciesAndMedicalLeave {
        params: {
            organizationId: string;
        };
    }

    export interface GetMedicalLeaveByOrganization {
        params: {
            organizationId: string;
        };
    }

    export interface DeletePolicy {
        params: {
            id: string;
        };
    }

    export interface OrganizationPublicPolicies {}

    export interface CreatePolicy {
        body: CreatePolicyDto;
    }

    export interface CreateBranch {
        body: CreateBranchDto;
    }

    export interface CreateTeam {
        body: CreateTeamDto;
    }

    export interface SetBranchAsMain {
        params: {
            id: string;
        };
    }

    export interface GetBranchById {
        params: {
            branchId: string;
        };
    }

    export interface GetTeam {
        params: {
            id: string;
        };
    }

    export interface PatchTeam {
        params: {
            id: string;
        };
        body: EditTeamDto;
    }

    export interface ChangeTeamLead {
        params: {
            id: string;
        };
        body: ChangeTeamLeadDto;
    }

    export interface PatchBranch {
        params: {
            branchId: string;
        };
        body: EditBranchDto;
    }

    export interface GetBranchesCount {}

    export interface GetBranchesFromOrganization {}

    export interface GetHolidaysByYear {
        query: {
            year: number;
        };
    }

    export interface DeleteHoliday {
        params: {
            id: string;
        };
    }

    export interface PostHoliday {
        body: CreateHolidayDto;
    }

    export interface PatchHoliday {
        params: {
            id: string;
        };
        body: EditHolidayDto;
    }

    export interface GetHolidayById {
        params: {
            id: string;
        };
    }

    export interface GetUserCardPaymentMethods {}

    export interface AddMethodIntent {}

    export interface ChangeDefaultMethodIntent {
        params: {
            methodId: string;
        };
    }

    export interface DeleteMethodIntent {
        params: {
            methodId: string;
        };
    }

    export interface UpdatePaymentMethod {
        params: {
            id: string;
        };
        body: UpdateCardPaymentMethodDto;
    }

    export interface GetHolidaysByBranch {
        params: {
            branchId?: string | null;
        };
    }

    export interface JoinOrganizationToken {
        body: {
            branchId?: string;
        };
    }

    export interface DeleteTeamWithUsers {
        body: {
            id: string;
        };
    }

    export interface DeleteTeamMember {
        params: {
            teamId: string;
            userSub: string;
        };
    }

    export interface AddTeamMembers {
        params: {
            id: string;
        };
        body: {
            userSubs: string[];
        };
    }

    export interface TransferOwnership {
        body: {
            newOwnerUserSub: string;
        };
    }

    export interface PatchMedicalLeave {
        params: {
            id: string;
        };
        body: EditMedicalLeaveDto;
    }

    export interface GetPricingPlans {
        body: {};
    }

    export interface CreateSubscription {
        body: {
            priceId: string;
        };
    }

    export interface CancelSubscription {
        body: {
            priceId: string;
        };
    }
    export interface GetActiveSubscription {}

    export interface GetAllInvoicesByCustomerPaginated {
        query?: {
            page?: number;
            size?: number;
            sort?: 'amount' | 'status' | 'billingDate';
            direction?: 'asc' | 'desc';
        };
    }

    export interface GetFeatureConfigs {}

    export interface GetFeatureConfigWithPlan {
        params: {
            feature: string;
        };
    }

    export interface GetReportSettings {}

    export interface PatchReportSettings {
        body: {
            excludeEmployee: boolean;
            excludeB2bContractor: boolean;
            excludeExternalCollaborator: boolean;
        };
    }
}

export namespace OrganizationApiResponse {
    export interface GetPricingPlans {
        body: PricingPlanDto[];
    }

    export interface OrganizationPublicData {
        body: OrganizationPublicDto;
    }
    export interface AskToJoinOrganizationResponse {}

    export interface OrganizationData {
        body: OrganizationDto;
    }

    export interface SendInviteEmails {
        body: string;
    }

    export interface UsersAskedToJoinOrganization {
        body: UserAskedToJoin[];
    }

    export interface Policy {
        body: PolicyDto;
    }

    export interface GetMembersOfLeadsTeam {
        body: string[];
    }

    export interface OrganizationWithPolicy {
        body: OrganizationWithPolicies;
    }

    export interface PoliciesAndMedicalLeaveInOrganization {
        body: PolicyAndMedicalLeaveBaseDto[];
    }

    export interface MedicalLeaveInOrganization {
        body: MedicalLeaveRequirements;
    }

    export interface PoliciesInOrganization {
        body: PolicyDto[];
    }

    export interface DeletePolicy {}

    export interface JoinOrganizationToken {
        body: string;
    }

    export interface OrganizationPublicPolicies {
        body: PublicPolicyDto[];
    }

    export interface GetFeatureConfigs {
        body: FeatureConfigResponseDto[];
    }

    export interface GetFeatureConfigWithPlan {
        body: GetForFeatureWithPlanResponseDto;
    }

    export interface GetReportSettings {
        body: {
            id: string;
            organizationId: string;
            excludeEmployee: boolean;
            excludeB2bContractor: boolean;
            excludeExternalCollaborator: boolean;
        };
    }

    export interface PatchReportSettings {
        body: {
            id: string;
            organizationId: string;
            excludeEmployee: boolean;
            excludeB2bContractor: boolean;
            excludeExternalCollaborator: boolean;
        };
    }

    export interface CreateBranch {
        body: BranchDto;
    }

    export interface CreateTeam {
        body: TeamDto;
    }

    export interface GetBranchById {
        body: BranchDto;
    }

    export interface GetTeam {
        body: TeamDto;
    }

    export interface PatchBranch {
        body: BranchDto;
    }

    export interface PatchTeam {
        body: TeamDto;
    }

    export interface GetBranchesCount {
        body: BranchesCountDto;
    }

    export interface GetBranchesFromOrganization {
        body: BranchDto[];
    }

    export interface GetHolidaysByYear {
        body: HolidaysWithBranchesDto[];
    }

    export interface DeleteHoliday {}

    export interface PostHoliday {
        body: HolidayDto;
    }

    export interface PatchHoliday {
        body: HolidayDto;
    }

    export interface GetHolidayById {
        body: HolidaysWithBranchesDto;
    }

    export interface GetHolidaysByBranch {
        body: HolidayDto[];
    }

    export interface TeamsWithUserData {
        body: TeamsWithUserData[];
    }

    export interface PoliciesByBranchAndOrganization {
        body: PolicyDto[];
    }

    export interface PatchMedicalLeave {
        body: MedicalLeaveDto;
    }

    export interface GetUserCardPaymentMethods {
        body: CardPaymentMethodDto[];
    }

    export interface AddMethodIntent {
        body: {
            clientSecret: string;
        };
    }

    export interface EmptyResponse {}

    export interface GetActiveSubscription {
        body: ActiveSubscriptionResponseDto | null;
    }

    export interface GetAllInvoicesByCustomerPaginated {
        body: {
            items: BillingInvoiceDto[];
            total: number;
            page: number;
            size: number;
            hasNext: boolean;
        };
    }
}

export namespace BranchApiRequest {
    export interface Delete {
        params: {
            id: string;
        };
    }
}

export namespace BranchApiResponse {
    export interface Delete {
        body: BranchDto;
    }
}

export namespace HolidayApiRequest {
    export interface GoogleImport {
        body: GoogleImportDto;
    }

    export interface PostGoogleHolidays {
        body: CreateGoogleHolidaysDto;
    }
}

export namespace HolidayApiResponse {
    export interface GoogleImport {
        body: GoogleImportHolidayDto[];
    }

    export interface PostGoogleHolidays {
        body: HolidayDto[];
    }
}

export namespace CurrencyApiResponse {
    export interface GetCurrencies {
        body: CurrencyDto[];
    }
}

export namespace TimezoneApiRequest {
    export interface GetTimezones {}
}

export namespace TimezoneApiResponse {
    export interface GetTimezones {
        body: TimezoneDto[];
    }
}
export namespace PolicyApiRequest {
    export interface GetPolicy {
        params: {
            id: string;
        };
    }
}

export namespace PolicyApiResponse {
    export interface GetPolicy {
        body: PolicyWithBranches;
    }
}

export namespace FeatureFlagsResponse {
    export interface GetFeatureFlags {
        body: FeatureFlagsDto[];
    }
}

export namespace SettingsApiResponse {
    export interface GetSettings {
        body: SettingsDto;
    }
}

export class OrganizationApi {
    constructor(private readonly apiBase: ApiBaseClass) {}

    public askToJoinOrganization(
        rest: IServiceHttp<OrganizationApiRequest.AskToJoinOrganization, OrganizationApiResponse.AskToJoinOrganizationResponse>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/organization/:organizationId/user.askToJoin',
        });
    }

    public createOrganization(rest: IServiceHttp<OrganizationApiRequest.CreateOrganization, OrganizationApiResponse.OrganizationData>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/organization',
        });
    }

    public sendInviteEmails(rest: IServiceHttp<OrganizationApiRequest.SendInviteEmails, OrganizationApiResponse.SendInviteEmails>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/organization/-inviteMembers',
        });
    }

    public usersAskedToJoinOrganization(
        rest: IServiceHttp<OrganizationApiRequest.UsersAskedToJoinOrganization, OrganizationApiResponse.UsersAskedToJoinOrganization>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/organization/:organizationId/users.askToJoin',
        });
    }

    public getOrganizationByOwnerId(
        rest: IServiceHttp<OrganizationApiRequest.GetOrganizationByOwnerId, OrganizationApiResponse.OrganizationPublicData>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/organization.getByOwnerId',
        });
    }

    public editPolicy(rest: IServiceHttp<OrganizationApiRequest.PatchPolicy, OrganizationApiResponse.Policy>) {
        return this.apiBase.configure({
            ...rest,
            method: 'PATCH',
            url: 'org/v1/policy/:id',
        });
    }

    public changeAffectedMembers(rest: IServiceHttp<OrganizationApiRequest.ChangeAffectedMembers, void>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/policy/id/:id/-changeAffectedMembers',
        });
    }

    public getOrganizationById(rest: IServiceHttp<OrganizationApiRequest.GetOrganizationById, OrganizationApiResponse.OrganizationWithPolicy>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/organization/:organizationId',
        });
    }

    public getPoliciesByOrganizationId(rest: IServiceHttp<OrganizationApiRequest.GetAllPolicies, OrganizationApiResponse.PoliciesInOrganization>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/policy/organizationId',
        });
    }

    public getPoliciesAndMedicalLeave(
        rest: IServiceHttp<OrganizationApiRequest.GetAllPoliciesAndMedicalLeave, OrganizationApiResponse.PoliciesAndMedicalLeaveInOrganization>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/organization/organizationId/:organizationId/policiesAndMedicalLeave',
        });
    }

    public patchOrganization(rest: IServiceHttp<OrganizationApiRequest.PatchOrganization, OrganizationApiResponse.OrganizationWithPolicy>) {
        return this.apiBase.configure({
            ...rest,
            method: 'PATCH',
            url: 'org/v1/organization/:organizationId',
        });
    }

    public deletePolicy(rest: IServiceHttp<OrganizationApiRequest.DeletePolicy, OrganizationApiResponse.DeletePolicy>) {
        return this.apiBase.configure({
            ...rest,
            method: 'DELETE',
            url: 'org/v1/policy/:id',
        });
    }

    public getJoinToken(rest: IServiceHttp<OrganizationApiRequest.JoinOrganizationToken, OrganizationApiResponse.JoinOrganizationToken>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/organization/-generateJoinToken',
        });
    }

    public getOrganizationPublicPolicies(
        rest: IServiceHttp<OrganizationApiRequest.OrganizationPublicPolicies, OrganizationApiResponse.OrganizationPublicPolicies>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/policy/organization/public',
        });
    }

    public createPolicy(rest: IServiceHttp<OrganizationApiRequest.CreatePolicy, OrganizationApiResponse.Policy>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/policy',
        });
    }

    public createBranch(rest: IServiceHttp<OrganizationApiRequest.CreateBranch, OrganizationApiResponse.CreateBranch>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/branch',
        });
    }

    public createTeam(rest: IServiceHttp<OrganizationApiRequest.CreateTeam, OrganizationApiResponse.CreateTeam>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/team',
        });
    }

    public setBranchAsMain(rest: IServiceHttp<OrganizationApiRequest.SetBranchAsMain, void>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/branch/id/:id/-setAsMain',
        });
    }

    public getBranchById(rest: IServiceHttp<OrganizationApiRequest.GetBranchById, OrganizationApiResponse.GetBranchById>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/branch/branchId/:branchId',
        });
    }

    public getTeam(rest: IServiceHttp<OrganizationApiRequest.GetTeam, OrganizationApiResponse.GetTeam>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/team/id/:id',
        });
    }

    public getMembersOfLeadsTeam(rest: IServiceHttp<{}, OrganizationApiResponse.GetMembersOfLeadsTeam>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/team/-membersOfLeadsTeam',
        });
    }

    public changeTeamLead(rest: IServiceHttp<OrganizationApiRequest.ChangeTeamLead, void>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/team/id/:id/-changeTeamLead',
        });
    }

    public editTeam(rest: IServiceHttp<OrganizationApiRequest.PatchTeam, OrganizationApiResponse.PatchTeam>) {
        return this.apiBase.configure({
            ...rest,
            method: 'PATCH',
            url: 'org/v1/team/id/:id',
        });
    }

    public editBranch(rest: IServiceHttp<OrganizationApiRequest.PatchBranch, OrganizationApiResponse.PatchBranch>) {
        return this.apiBase.configure({
            ...rest,
            method: 'PATCH',
            url: 'org/v1/branch/branchId/:branchId',
        });
    }

    public deleteBranch(rest: IServiceHttp<BranchApiRequest.Delete, BranchApiResponse.Delete>) {
        return this.apiBase.configure({
            ...rest,
            method: 'DELETE',
            url: 'org/v1/branch/id/:id',
        });
    }

    public getBranchesCount(rest: IServiceHttp<OrganizationApiRequest.GetBranchesCount, OrganizationApiResponse.GetBranchesCount>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/branch/count',
        });
    }

    public getBranchesFromOrganization(
        rest: IServiceHttp<OrganizationApiRequest.GetBranchesFromOrganization, OrganizationApiResponse.GetBranchesFromOrganization>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/branch/organization',
        });
    }

    public getHolidaysByYear(rest: IServiceHttp<OrganizationApiRequest.GetHolidaysByYear, OrganizationApiResponse.GetHolidaysByYear>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/holiday',
        });
    }

    public deleteHoliday(rest: IServiceHttp<OrganizationApiRequest.DeleteHoliday, OrganizationApiResponse.DeleteHoliday>) {
        return this.apiBase.configure({
            ...rest,
            method: 'DELETE',
            url: 'org/v1/holiday/id/:id',
        });
    }
    public postHoliday(rest: IServiceHttp<OrganizationApiRequest.PostHoliday, OrganizationApiResponse.PostHoliday>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/holiday',
        });
    }

    public editHoliday(rest: IServiceHttp<OrganizationApiRequest.PatchHoliday, OrganizationApiResponse.PatchHoliday>) {
        return this.apiBase.configure({
            ...rest,
            method: 'PATCH',
            url: 'org/v1/holiday/id/:id',
        });
    }

    public getHolidayById(rest: IServiceHttp<OrganizationApiRequest.GetHolidayById, OrganizationApiResponse.GetHolidayById>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/holiday/id/:id',
        });
    }
    public googleImport(rest: IServiceHttp<HolidayApiRequest.GoogleImport, HolidayApiResponse.GoogleImport>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/holiday/-google-import',
        });
    }

    public postGoogleHolidays(rest: IServiceHttp<HolidayApiRequest.PostGoogleHolidays, HolidayApiResponse.PostGoogleHolidays>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/holiday/-bulk',
        });
    }

    public getCurrencies(rest: IServiceHttp<{}, CurrencyApiResponse.GetCurrencies>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/currency',
        });
    }

    public getHolidaysByBranch(rest: IServiceHttp<OrganizationApiRequest.GetHolidaysByBranch, OrganizationApiResponse.GetHolidaysByBranch>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/holiday/branchId/:branchId',
        });
    }

    public getTimezones(rest: IServiceHttp<TimezoneApiRequest.GetTimezones, TimezoneApiResponse.GetTimezones>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/timezone',
        });
    }

    public getPolicy(rest: IServiceHttp<PolicyApiRequest.GetPolicy, PolicyApiResponse.GetPolicy>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/policy/id/:id',
        });
    }

    public deleteTeam(rest: IServiceHttp<OrganizationApiRequest.DeleteTeamWithUsers, OrganizationApiResponse.TeamsWithUserData>) {
        return this.apiBase.configure({
            ...rest,
            method: 'DELETE',
            url: 'org/v1/team/id/:id',
        });
    }

    public deleteTeamMember(rest: IServiceHttp<OrganizationApiRequest.DeleteTeamMember, void>) {
        return this.apiBase.configure({
            ...rest,
            method: 'DELETE',
            url: 'org/v1/team/teamId/:teamId/userSub/:userSub',
        });
    }

    public addTeamMembers(rest: IServiceHttp<OrganizationApiRequest.AddTeamMembers, void>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/team/id/:id/-addMembers',
        });
    }

    public getPoliciesByBranchAndOrganization(
        rest: IServiceHttp<OrganizationApiRequest.PoliciesByBranchAndOrganization, OrganizationApiResponse.PoliciesByBranchAndOrganization>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/branch/:branchId/organizationId/:organizationId/policies',
        });
    }

    public transferOwnership(rest: IServiceHttp<OrganizationApiRequest.TransferOwnership, void>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/organization/:organizationId/transfer-ownership',
        });
    }

    public getFeatureFlags(rest: IServiceHttp<{}, FeatureFlagsResponse.GetFeatureFlags>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/feature-flags',
        });
    }

    public getSettings(rest: IServiceHttp<{}, SettingsApiResponse.GetSettings>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/settings/-byOrganization',
        });
    }

    public editMedicalLeave(rest: IServiceHttp<OrganizationApiRequest.PatchMedicalLeave, OrganizationApiResponse.PatchMedicalLeave>) {
        return this.apiBase.configure({
            ...rest,
            method: 'PATCH',
            url: 'org/v1/medical-leave/id/:id',
        });
    }

    public getMedicalLeaveByOrganization(
        rest: IServiceHttp<OrganizationApiRequest.GetMedicalLeaveByOrganization, OrganizationApiResponse.MedicalLeaveInOrganization>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/medical-leave/organizationId/:organizationId',
        });
    }

    public getPricingPlans(rest: IServiceHttp<OrganizationApiRequest.GetPricingPlans, OrganizationApiResponse.GetPricingPlans>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/product/pricing-plans',
        });
    }

    public getUserCardPaymentMethods(
        rest: IServiceHttp<OrganizationApiRequest.GetUserCardPaymentMethods, OrganizationApiResponse.GetUserCardPaymentMethods>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/payments/cards',
        });
    }

    public addMethodIntent(rest: IServiceHttp<OrganizationApiRequest.AddMethodIntent, OrganizationApiResponse.AddMethodIntent>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/payments/method-intent',
        });
    }

    public changeDefaultMethodIntent(rest: IServiceHttp<OrganizationApiRequest.ChangeDefaultMethodIntent, OrganizationApiResponse.EmptyResponse>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/payments/methods/:methodId/default',
        });
    }

    public deletetMethodIntent(rest: IServiceHttp<OrganizationApiRequest.DeleteMethodIntent, OrganizationApiResponse.EmptyResponse>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/payments/methods/:methodId/detach',
        });
    }

    public updatePaymentMethod(rest: IServiceHttp<OrganizationApiRequest.UpdatePaymentMethod, OrganizationApiResponse.EmptyResponse>) {
        return this.apiBase.configure({
            ...rest,
            method: 'PUT',
            url: 'org/v1/payments/methods/id/:id',
        });
    }

    public createSubscription(rest: IServiceHttp<OrganizationApiRequest.CreateSubscription, OrganizationApiResponse.EmptyResponse>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/payments/subscription',
        });
    }

    public cancelSubscription(rest: IServiceHttp<OrganizationApiRequest.CancelSubscription, OrganizationApiResponse.EmptyResponse>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'org/v1/payments/subscription/cancel',
        });
    }

    public getActiveSubscription(rest: IServiceHttp<OrganizationApiRequest.GetActiveSubscription, OrganizationApiResponse.GetActiveSubscription>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/payments/subscription/active',
        });
    }

    public getAllInvoicesByCustomerPaginated(
        rest: IServiceHttp<OrganizationApiRequest.GetAllInvoicesByCustomerPaginated, OrganizationApiResponse.GetAllInvoicesByCustomerPaginated>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/payments/invoices',
        });
    }

    public getFeatureConfigs(rest: IServiceHttp<OrganizationApiRequest.GetFeatureConfigs, OrganizationApiResponse.GetFeatureConfigs>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/feature-configs',
        });
    }

    public getFeatureConfigWithPlan(
        rest: IServiceHttp<OrganizationApiRequest.GetFeatureConfigWithPlan, OrganizationApiResponse.GetFeatureConfigWithPlan>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/feature-config/:feature/with-plan',
        });
    }

    public getReportSettings(rest: IServiceHttp<OrganizationApiRequest.GetReportSettings, OrganizationApiResponse.GetReportSettings>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/report-settings/-byOrganization',
        });
    }

    public patchReportSettings(rest: IServiceHttp<OrganizationApiRequest.PatchReportSettings, OrganizationApiResponse.PatchReportSettings>) {
        return this.apiBase.configure({
            ...rest,
            method: 'PATCH',
            url: 'org/v1/report-settings/-byOrganization',
        });
    }
}

diContainer.bindAsDynamic(OrganizationApi, c => new OrganizationApi(c.get(ApiBaseClass)));
